import { convertToMoment, pWorkItemTypesArray } from "../../../store/api/CommonFunctions";

export const getTableColumns = (type) => {
    const title = pWorkItemTypesArray[type - 1];
    const tableColumns = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: `شماره `, colName: "Number", showInMobile: true },
        { colTitle: `نوع`, colName: "PType", showInMobile: true },
        { colTitle: `عنوان`, colName: "Title" },
        { colTitle: "ثبت کننده", colName: "CreateByName" },
        { colTitle: "تاریخ ثبت", colName: "PCreationDate" },
        { colTitle: "اهمیت", colName: "PSeverity" },
        { colTitle: "اولویت", colName: "PPriority" },
        { colTitle: "وضعیت", colName: "Status" }
    ];
    return tableColumns;
}
export const fixDateFilters = (filterData) => {
    if (filterData) {
        if (filterData.CreationDateFrom)
            filterData.CreationDateFrom = convertToMoment(filterData.CreationDateFrom);
        if (filterData.CreationDateTo)
            filterData.CreationDateTo = convertToMoment(filterData.CreationDateTo);
    }
    return filterData;
}

